export default __webpack_public_path__ + "static/media/border-vertical-2.f04a959d.webp";